import React from "react";

const TIERS = [
  "Core: $1,500/site/month + $5,000 setup. Includes WSafe AI, HazardLoop, WorkSafeStory.",
  "Pro: $3,000/site/month + $10,000 setup. Includes everything in Core plus InductIQ and EnviSafe.",
  "Vision: $6,250/site/month + $25,000 setup. Includes everything in Pro plus SafeForm and continuous CCTV detection.",
  "Founding paid pilot: $1,000, no install fee.",
];

const SERVICES = [
  "Compliance Evaluation & Documentation Service: $1,500 evaluation; then Essentials $500, Standard $1,000 or Premium $2,000 per site/month, billed in addition to a Core or Pro subscription. Covers OSHA and environmental records. Documentation setup is included in the setup fee; work beyond included hours is $150/hr.",
  "Consulting: $150/hr; $1,500 gap review; $1,500/day audit; $2,500 AI readiness assessment (credited toward a paid pilot); $1,200/month retainer. No travel charge for on-site work within 50 miles of Abilene, Texas.",
];

export default function UniversalPricing() {
  return (
    <div className="border border-ink-900 bg-white" data-testid="universal-pricing-block">
      <div className="p-8 border-b border-ink-100">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-500 mb-5">
          Subscriptions, per site per month, plus one-time setup per site:
        </div>
        <ul className="space-y-4">
          {TIERS.map((t, i) => {
            const [name, ...rest] = t.split(": ");
            return (
              <li key={name} data-testid={`pricing-line-${i}`} className={`pl-4 border-l-2 ${name === "Vision" ? "border-safety" : "border-ink-100"} text-ink-700 leading-relaxed`}>
                - <span className="font-display font-bold text-ink-900">{name}:</span> {rest.join(": ")}
              </li>
            );
          })}
        </ul>
      </div>
      {SERVICES.map((s, i) => {
        const [name, ...rest] = s.split(": ");
        return (
          <p key={name} data-testid={`pricing-service-${i}`} className="p-8 border-b border-ink-100 last:border-b-0 text-ink-700 leading-relaxed">
            <span className="font-display font-bold text-ink-900">{name}:</span> {rest.join(": ")}
          </p>
        );
      })}
    </div>
  );
}
